import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  organizationService,
  CreateOrganizationWithPaymentPayload,
} from '@services/organization';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateOrganizationWithPayment = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['organizations', 'create-with-payment'],
    mutationFn: async (payload: CreateOrganizationWithPaymentPayload) => {
      return await organizationService.createOrganizationWithPayment(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      queryClient.invalidateQueries({ queryKey: ['user-organizations'] });
      queryClient.invalidateQueries({ queryKey: ['organization'] });
      queryClient.invalidateQueries({ queryKey: ['user'] });
      toast.success(tActionMessages.organizationCreatedRedirecting);

      // Reload the page to ensure fresh state and proper redirect to new organization
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    },
    onError: (error: any) => {
      console.error('Create organization with payment error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        error?.toString() ||
        'Failed to create organization. Please check your payment details and try again.';
      toast.error(errorMessage);
    },
  });
};

export default useCreateOrganizationWithPayment;
